import React, { useState, useEffect } from "react";
import "./FilterComponent.css";
import axios from "axios";

const FilterComponent = ({ selectedFilters, setSelectedFilters }) => {
  const [dropData, setDropData] = useState({});
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const loadDropdowns = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/auth/v1/dropdowns`
        );
        setDropData(response.data);
      } catch (error) {
        console.error("Error loading dropdowns:", error);
      }
    };
    loadDropdowns();
  }, []);

  const handleCheckboxChange = (filterCategory, value) => {
    setSelectedFilters((prevFilters) => {
      const updatedCategory = prevFilters[filterCategory].includes(value)
        ? prevFilters[filterCategory].filter((item) => item !== value)
        : [...prevFilters[filterCategory], value];

      return {
        ...prevFilters,
        [filterCategory]: updatedCategory,
      };
    });
  };

  const handleSelectAll = () => {
    setSelectedFilters({
      shape: [],
      color: [],
      vendor: [],
      teethCase: [],
      width: "",
      height: "",
      mass: "",
      alphaCode: "",
    });
  };

  const handleInputChange = (e, field) => {
    const { value } = e.target;
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  return (
    <div className="filter-container">
      {/* Mobile Toggle Button */}
      <button
        className="mobile-filter-toggle"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? "Close Filters" : "Open Filters"}
      </button>

      <div className={`filter-content ${isMobileOpen ? "open" : ""}`}>
        <div className="filter-section">
          <button onClick={handleSelectAll} className="clear-filters">
            Clear all filters
          </button>

          <h3>Filter by Size</h3>
          <div className="side">
            <div className="wh">
              <input
                type="text"
                placeholder="Mold Number"
                value={selectedFilters.alphaCode || ""}
                onChange={(e) => handleInputChange(e, "alphaCode")}
              />
            </div>
            <input
              type="number"
              placeholder="Total Width"
              value={selectedFilters.mass || ""}
              onChange={(e) => handleInputChange(e, "mass")}
            />
            <div className="wh">
              <input
                type="number"
                placeholder="Width"
                value={selectedFilters.width || ""}
                onChange={(e) => handleInputChange(e, "width")}
              />
              <input
                type="number"
                placeholder="Height"
                value={selectedFilters.height || ""}
                onChange={(e) => handleInputChange(e, "height")}
              />
            </div>
          </div>
        </div>

        <div className="filter-section">
          <h3>Filter by Shape</h3>
          {dropData?.Shapes?.map((m) => (
            <label key={m.name}>
              <input
                type="checkbox"
                checked={selectedFilters.shape?.includes(m.name)}
                onChange={() => handleCheckboxChange("shape", m.name)}
              />
              {m.name}
            </label>
          ))}
        </div>

        <div className="filter-section">
          <h3>Filter by Color</h3>
          {dropData?.Colors?.map((m) => (
            <label key={m.name}>
              <input
                type="checkbox"
                checked={selectedFilters.color?.includes(m.name)}
                onChange={() => handleCheckboxChange("color", m.name)}
              />
              {m.name}
            </label>
          ))}
        </div>

        <div className="filter-section">
          <h3>Filter by Vendor</h3>
          {dropData?.Vendors?.map((m) => (
            <label key={m.name}>
              <input
                type="checkbox"
                checked={selectedFilters.vendor?.includes(m.name)}
                onChange={() => handleCheckboxChange("vendor", m.name)}
              />
              {m.name}
            </label>
          ))}
        </div>

        <div className="filter-section">
          <h3>Filter by Case</h3>
          {dropData?.Cases?.map((m) => (
            <label key={m.name}>
              <input
                type="checkbox"
                checked={selectedFilters.teethCase?.includes(m.name)}
                onChange={() => handleCheckboxChange("teethCase", m.name)}
              />
              {m.name}
            </label>
          ))}
        </div>

        <button className="apply-filters">Apply Filters</button>
      </div>
    </div>
  );
};

export default FilterComponent;
